import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaTiktok, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { MdOutlineLocalHospital } from 'react-icons/md';

function Footer() {
  return (
    <footer className="w-full">


      {/* Main Footer */}
      <div className="bg-[#002147] dark:bg-gray-900 text-white pt-16 pb-8 w-full">
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Information */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center overflow-hidden p-1">
                <img src="/assets/images/aman-logo-new.png" alt="Aman Medical Complex Gilgit Logo" className="w-full h-full object-contain mix-blend-multiply" />
              </div>
              <span className="text-2xl font-black">Aman Medical Complex Gilgit</span>
            </div>
            <p className="text-gray-300 dark:text-gray-400 mb-8 leading-relaxed text-sm">
              We strive to create a welcoming environment where patients feel valued respected and well informed about their health
            </p>
            <div>
              <p className="text-white font-bold text-sm mb-4">Follow Us:</p>
              <div className="flex gap-3">
                <a 
                  href="https://www.facebook.com/AMHGLT/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Visit our Facebook page"
                  className="w-10 h-10 rounded-full bg-[#001030] dark:bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors text-white focus:outline-none focus:ring-2 focus:ring-primary-400"
                >
                  <FaFacebookF />
                </a>
                <a 
                  href="#" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Visit our TikTok page"
                  className="w-10 h-10 rounded-full bg-[#001030] dark:bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors text-white focus:outline-none focus:ring-2 focus:ring-primary-400"
                >
                  <FaTiktok />
                </a>
                <a href="#" className="w-10 h-10 rounded-full bg-[#001030] dark:bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors text-white">
                  <FaInstagram />
                </a>
                <a href="#" className="w-10 h-10 rounded-full bg-[#001030] dark:bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors text-white">
                  <FaLinkedinIn />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-xl font-black mb-6 relative pb-3">
              Quick Links
              <span className="absolute bottom-0 left-0 w-12 h-1 bg-[#007bff]"></span>
            </h3>
            <ul className="space-y-4">
              <li><Link to="/services" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">Medical Directory</Link></li>
              <li><Link to="/doctors" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">Top Doctors</Link></li>
              <li><Link to="#" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">Latest News</Link></li>
              <li><Link to="/about" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">Why Choose Us</Link></li>
              <li><Link to="/contact" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Useful Links */}
          <div>
            <h3 className="text-white text-xl font-black mb-6 relative pb-3">
              Useful Links
              <span className="absolute bottom-0 left-0 w-12 h-1 bg-[#007bff]"></span>
            </h3>
            <ul className="space-y-4">
              <li><Link to="#" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">Featured Hospitals</Link></li>
              <li><Link to="#" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">How It Works</Link></li>
              <li><Link to="/contact" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">Find A Location</Link></li>
              <li><Link to="/doctors" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">Doctors Search</Link></li>
              <li><Link to="#" className="text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm">Telemedicine Services</Link></li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="text-white text-xl font-black mb-6 relative pb-3">
              Contact Us
              <span className="absolute bottom-0 left-0 w-12 h-1 bg-[#007bff]"></span>
            </h3>
            <div className="space-y-4">
              <a href="tel:+925581234567" className="flex items-start gap-3 text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm group">
                <span className="w-10 h-10 rounded-xl bg-[#001030] dark:bg-gray-800 flex items-center justify-center text-[#007bff] flex-shrink-0 group-hover:bg-[#007bff] group-hover:text-white transition-colors">
                  <FaPhoneAlt size={14} />
                </span>
                <span className="pt-2">+92 558 1234567</span>
              </a>
              <a href="mailto:info@amanmedicalcomplex.com" className="flex items-start gap-3 text-gray-300 dark:text-gray-400 hover:text-[#007bff] transition-colors text-sm group">
                <span className="w-10 h-10 rounded-xl bg-[#001030] dark:bg-gray-800 flex items-center justify-center text-[#007bff] flex-shrink-0 group-hover:bg-[#007bff] group-hover:text-white transition-colors">
                  <FaEnvelope size={14} />
                </span>
                <span className="pt-2">info@amanmedicalcomplex.com</span>
              </a>
              <div className="flex items-start gap-3 text-gray-300 dark:text-gray-400 text-sm">
                <span className="w-10 h-10 rounded-xl bg-[#001030] dark:bg-gray-800 flex items-center justify-center text-[#007bff] flex-shrink-0">
                  <FaMapMarkerAlt size={14} />
                </span>
                <span className="pt-2">Aman Medical Complex, Sakwar, Gilgit</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="container mx-auto px-4 mt-16 pt-8 border-t border-gray-700 text-center text-sm text-gray-400">
          <p>&copy; 2026 Aman Medical Complex Gilgit. All rights reserved.</p>
          <p className="mt-2">Developed by <a href="https://www.codeovapk.com/" target="_blank" rel="noopener noreferrer" className="text-[#007bff] hover:text-[#0062cc] transition-colors font-semibold">Codeova</a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;